import { ORDER_SALES_CHANNELS, type OrderSalesChannel } from '@wapharma/shared';
import { SegmentedControl, type SegmentedControlProps } from '../primitives/SegmentedControl.js';

/** Filter mode for order/reservation/stock-movement channel dimension (`all` = no filter). */
export type ChannelMode = 'all' | OrderSalesChannel;

const CHANNEL_FILTER_LABELS: Record<OrderSalesChannel, string> = {
  ECOMMERCE: 'Site',
  SHOWROOM: 'Showroom',
};

const OPTIONS: SegmentedControlProps<ChannelMode>['options'] = [
  { value: 'all', label: 'Tous' },
  ...ORDER_SALES_CHANNELS.map((ch) => ({ value: ch, label: CHANNEL_FILTER_LABELS[ch] })),
];

export type ChannelSwitchProps = {
  value: ChannelMode;
  onChange: (v: ChannelMode) => void;
};

/** Global channel filter for projections (read-model). */
export function ChannelSwitch({ value, onChange }: ChannelSwitchProps) {
  return <SegmentedControl value={value} onChange={onChange} options={OPTIONS} aria-label="Canal" />;
}
